import { createTheme } from "@mui/material";

import { BLUE, LIGHT_BLUE, DARK_BLUE, AQUA, LIGHT_AQUA, DARK_AQUA, WHITE } from '@wave-engagement/wave-react';

export default createTheme({
  palette: {
    primary: {
      main: BLUE,
      light: LIGHT_BLUE,
      DARK: DARK_BLUE,
      contrastText: WHITE,
    },
    secondary: {
      main: AQUA,
      light: LIGHT_AQUA,
      DARK: DARK_AQUA,
      contrastText: WHITE,
    },
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    h1: {
      fontSize: 50,
      textAlign: 'center'
    },
    h2: {
      fontSize: 38
    },
    h3: {
      fontSize: 32
    },
    h4: {
      fontSize: 26
    }
  }
});